import { ref, watch, computed } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Vue from 'vue'
import axios from 'axios'
import apiEndpoints from '@/constants/apiEndpoints'
import router from '../../../../router'

export default function useRegionsList() {
  const toast = useToast()
  const refRegionListTable = ref(null)
  const loading = ref(false)

  const tableColumns = [
    { key: 'region_name', sortable: true },
    { key: 'region_code', sortable: true },
    { key: 'branches', sortable: false, label: 'Branches' },
    { key: 'actions' },
  ]

  const perPage = ref(10)
  const totalRegions = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('region_name')
  const isSortDirDesc = ref(true)

  const dataMeta = computed(() => {
    const localItemsCount = refRegionListTable.value ? refRegionListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRegions.value,
    }
  })

  const refetchData = () => {
    if (refRegionListTable.value) {
      refRegionListTable.value.refresh()
    }
  }

  watch([currentPage, perPage, searchQuery, sortBy, isSortDirDesc], () => {
    refetchData()
  })

  const fetchRegions = (ctx, callback) => {
    loading.value = true
    const to = perPage.value * (currentPage.value - 1)
    const userToken = Vue.$cookies.get('userToken')
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userToken}`,
    }

    axios
      .get(`${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_REGIONS_WITH_BRANCHES}`, {
        headers,
        params: {
          search: searchQuery.value,
          order_by: sortBy.value,
          order_sort: isSortDirDesc.value ? 'DESC' : 'ASC',
          limit: perPage.value,
          offset: to,
        },
      })
      .then(response => {
        if (response.data && response.data.data !== null) {
          totalRegions.value = response.data.total_rows || 0
          callback(response.data.data)
        } else {
          callback([])
        }
        loading.value = false
      })
      .catch(e => {
        loading.value = false
        if (e.message === 'Request failed with status code 401') {
          router.push({ name: 'auth-login' })
        } else {
          console.error(e)
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error fetching regions list',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }
      })
  }

  return {
    fetchRegions,
    loading,
    tableColumns,
    perPage,
    currentPage,
    totalRegions,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refRegionListTable,
    refetchData,
  }
}